"use client";
import type { SettingsHeaderProps } from "../settings/settings-header";
import { SettingsHeader } from "../settings/settings-header";

const ProfileHeader = ({
    data,
    isExpanded,
    title,
    headers,
    open,
    onClose = () => {},
    remove,
}: SettingsHeaderProps) => {
    const updatedHeaders = {
        ...headers,
        newTitle: headers.newTitle || title,
    };

    return (
        <SettingsHeader
            data={data}
            isExpanded={isExpanded}
            remove={remove}
            title={title}
            headers={updatedHeaders}
            open={open}
            id={null}
            onClose={onClose}
        />
    );
};

export default ProfileHeader;
